import React from 'react'
import Header from '../Integration/DashboardHeader'
import SideBarMenu from '../Integration/DashboardSideBarMenu'
import FormList from '../Integration/FormOrderProduct'
import { useBusinessAuth } from '../../Middleware/context/BusinessContext'

function DashboardListProduto() {

const {companyProfile}=useBusinessAuth()


  return (
    <div>
        
        
     
      <div className="homeheader">
        <Header/>

      </div>

     <div className="homebody">



      <div className="homeleft">

      <SideBarMenu/>

      </div>
      <div className="homeright">

        <div className="upright">

          <label className='' >Empresa: {companyProfile.nome}</label>  
           <span className='' >NIF: {companyProfile.nif}</span> 
            <span className='' >Regiao: {companyProfile.pais}</span> 
        </div>
        <div className="downright">
            < FormList />

        </div>
        <div className='footageright'>

        </div>

      </div>
     </div>
        
        
        </div>
  )
}

export default DashboardListProduto